<template>
  <div id="example-fish-otd">
    <template v-for="post of posts.data">
      <v-card :key="post.FamCode" v-if="posts">
        <v-img
          src="http://www.azgardens.com/wp-content/uploads/2017/06/Leopard-Gourami-Fish.jpg"
          href="http://www.azgardens.com/wp-content/uploads/2017/06/Leopard-Gourami-Fish.jpg"
          aspect-ratio="1.5"
        ></v-img>

        <v-card-title primary-title :key="post.FBname">
          <div v-if="post.FBname">
            <h3 class="headline mb-0">{{post.FBname}}</h3>
            <div>
              <i>{{post.Genus + ' ' + post.Species}}</i>
            </div>
          </div>
        </v-card-title>

        <v-card-text>
          <h3>DATA</h3>
          <hr>
            <ul>
              <li>
                <p><b>Genus: </b>{{post.Genus}}</p>
              </li>
              <li>
                <p><b>Species: </b>{{post.Species}}</p>
              </li>
              <li>
                <p><strong>Aquarium: </strong>{{post.Aquarium}}</p>
              </li>
              <li>
                <p><strong>AquariumFishII: </strong>{{post.AquariumFishII}}</p>
              </li>
              <li>
                <p><strong>AquariumRef: </strong>{{post.AquariumRef}}</p>
              </li>
              <li>
                <p><strong>Author: </strong>{{post.Author}}</p>
              </li>
              <li>
                <p><strong>Dangerous: </strong>{{post.Dangerous}}</p>
              </li>
              <li>
                <p><strong>Date Checked: </strong>{{post.DateChecked}}</p>
              </li>
              <li>
                <p><b>Date Entered: </b>{{post.DateEntered}}</p>
              </li>
              <li>
                <p><b>Date Modified: </b>{{post.DateModified}}</p>
              </li>
              <li>
                <p><b>DemersPelag: </b>{{post.DemersPelag}}</p>
              </li>
              <li>
                <p><b>Electrogenic: </b>{{post.Electrogenic}}</p>
              </li>
              <li>
                <p><b>Fishbase Entries: </b>{{post.Entered}}</p>
              </li>
              <li>
                <p><b>Family DB Code: </b>{{post.FamCode}}</p>
              </li>
              <li>
                <p><b>Genus DB Code: </b>{{post.GenCode}}</p>
              </li>
              <li>
                <p><b>Length: </b>{{post.Length}} cm</p>
              </li>
            </ul>

            <ul v-if="errors && errors.length">
              <li v-for="error of errors" :key="error">
                {{error.message}}
              </li>
            </ul>
        </v-card-text>

      </v-card>
    </template>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      posts: [],
      images: [],
      errors: [],
      FishBaseURL: 'https://fishbase.ropensci.org',
      fishbaseRoutes: [
        '/',
        '/heartbeat',
        '/docs',
        '/comnames',
        '/ecology',
        '/ecosystem',
        '/genera',
        '/species',
        '/synonyms',
        '/taxa'
      ],
      NatureServeImageURL: `https://services.natureserve.org/idd/rest/ns/v1/globalSpecies/images`,
      gbifURL:`http://api.gbif.org/v1`,
      wikiMediaURL: `https://en.wikipedia.org/w/api.php`,
      wikiMediaResponse: [],
      gbifResponse: []
    }
  },

  methods: {
    searchFishBase: function (searchTerm) {
      axios.get(this.FishBaseURL + searchTerm)
      .then (response => {
        this.posts = response.data
      })
      .catch (e => {
        this.errors.push(e)
      })
    }
  },

  created () {
    this.searchFishBase('/species?species=acutirostre&limit=1')
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/sandbox/examples/fishOTD.vue